
import AccettazioneSsnSchedaPazientePage from "./pages/AccettazioneSsnSchedaPazientePage.vue"
import AccettazionePrenotazioniLazioListPage from "./pages/AccettazionePrenotazioniLazioListPage.vue";
import AccettazioneSsnEditViewPageN from "./pages/AccettazioneSsnEditViewPage.vue";
import AccettazioneSsnListPageN from "./pages/AccettazioneSsnListaPage.vue";

export default {
    AccettazioneSsnSchedaPazientePage,
    AccettazioneSsnEditViewPageN,
    AccettazioneSsnListPageN,
    AccettazionePrenotazioniLazioListPage
};
